<template>
    <div class="body_div">
        <div class="content_div">
            <div class="top_card">
                <div class="top_button" style="font-size: 28px;color: black;">毕业论文管理系统</div>
                <!--                <div @click="goLogin" class="top_button">去注册</div>-->
            </div>
            <el-card>
                <el-form :model="data" :rules="rules" ref="data" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="身份" prop="roleId">
                        <el-select v-model="data.roleId" placeholder="请选择身份">
                            <el-option
                                v-for="item in roleList"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户名" prop="userName">
                        <el-input v-model="data.userName"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input v-model="data.password" type="password"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="btnLogin('data')">立即登录</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
    </div>
</template>
<script>
import {reqGetUserInfo, reqUsersLogin} from "@/api/Users";
import {setToken} from "@/utils/SessionStorage";

const roleList1 = [{id: 1, label: "管理员"}, {id: 2, label: "教师"}, {id: 3, label: "学生"},]
export default {
    name: "Login",
    created() {
    },
    methods: {
        goLogin() {
            this.$router.push("/register");
        },
        goIndex() {
            this.$router.push("/home/index");
        },
        //用户登录
        async btnLogin(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let {data} = await reqUsersLogin(this.data);
                    setToken(data);
                    let res = await reqGetUserInfo();
                    sessionStorage.setItem("loginName", res.data.nickName);
                    sessionStorage.setItem("loginInfo", JSON.stringify(res.data));
                    this.$message.success("登录成功")
                    this.goIndex();
                }
            })
        }
    },
    data() {
        return {
            total: 0,
            roleList: roleList1,
            query: {},
            data: {},
            rules: {
                roleId: [{required: true, message: "请选择角色", trigger: "blur"}],
                userName: [{required: true, message: "请输入用户名", trigger: "blur"}],
                password: [{required: true, message: "请输入密码", trigger: "blur"}]
            }
        }
    }
}
</script>
<style scoped lang="scss">
.content_div {
    justify-content: center;
    width: 25%;
    position: absolute;
    top: 30%;
    left: 35%;
}

.top_button {
    cursor: pointer;
}

.body_div {
    background-color: #1e9fff;
    //background-image: url("@/assets/bg.jpg");
    width: 100%;
    height: 100vh;
    //background-color: #92a8a9;
}

.top_card {
    background-color: #447aa2;
    color: white;
    height: 50px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 10px 30px;
}
</style>
